module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.recipes.edit.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    attrs: {
      "value": "1"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.recipes.formTabs.recipeInformation'),
      "name": "1"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.recipes",
      "hasLabel": true
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.recipes.formTabs.ingrediencesAndProcedures'),
      "name": "2"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('fieldset', {
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('legend', [_vm._v(" " + _vm._s(_vm.$t('static.recipes.edit.ingrediences')))]), _vm._v(" "), _c('v-form-table', {
    attrs: {
      "form": _vm.formIngredience,
      "list": _vm.ingredienceList,
      "additionalButtons": _vm.addIngrediencesButton,
      "update": _vm.updateIngredience,
      "destroy": _vm.destroyIngredience,
      "hiddenFields": _vm.hiddenFields,
      "noResultWarningText": _vm.$t('table.recipeIngrediences.noResult'),
      "translation": "table.recipeIngrediences"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('fieldset', {
    staticStyle: {
      "padding-top": "15px",
      "margin-top": "15px"
    }
  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('static.recipes.edit.procedures')))]), _vm._v(" "), _c('el-button', {
    staticClass: "small margin-b-10",
    on: {
      "click": _vm.addProcedure
    }
  }, [_vm._v(_vm._s(_vm.$t('button.add')) + "\n              ")]), _vm._v(" "), _vm._l((_vm.procedureList), function(procedure) {
    return _c('el-card', {
      key: procedure.id,
      staticClass: "box-card margin-b-10",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "shadow": "never"
      }
    }, [_c('div', {
      staticClass: "flex",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', [(procedure.step) ? _c('b', {
      staticStyle: {
        "font-weight": "700"
      }
    }, [_vm._v(_vm._s(_vm.$t('static.recipes.edit.step')) + "\n                        " + _vm._s(procedure.step) + " -")]) : _vm._e(), _vm._v("\n                      " + _vm._s(procedure.name) + "\n                    ")]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "margin-left": "auto",
        "padding": "7px 12px"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.editProcedure(procedure)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('button.edit')))])], 1), _vm._v(" "), (procedure.ingrediences.length) ? _c('small', [_vm._v(_vm._s(_vm.$t('static.recipes.edit.ingrediences')) + " ")]) : _vm._e(), _vm._v(" "), _vm._l((procedure.ingrediences), function(ingredience) {
      return (procedure.ingrediences) ? _c('li', {
        key: ingredience.id,
        staticClass: "text item"
      }, [_c('b', [_vm._v(_vm._s(ingredience.materialName))]), _vm._v(" - " + _vm._s(ingredience.amount) + " " + _vm._s(ingredience.unitMeasure) + "\n                  ")]) : _vm._e()
    }), _vm._v(" "), (procedure.equipment) ? _c('small', [_vm._v(_vm._s(_vm.$t('static.recipes.edit.equipment')))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v(_vm._s(procedure.equipment))])], 2)
  })], 2)])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.recipes.formTabs.products'),
      "name": "3"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('v-form-table', {
    attrs: {
      "form": _vm.formProduct,
      "list": _vm.productList,
      "additionalButtons": _vm.addProductsButton,
      "destroy": _vm.destroyProduct,
      "noResultWarningText": "No products yet.",
      "translation": "form.recipes"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "full-w flex justify-center buttons_under_main_body"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'production.recipes.index'
      }
    }
  }, [_c('el-button', {
    staticClass: "dark"
  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "outline",
    attrs: {
      "loading": _vm.form.loading
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b97a6120","hasScoped":true}!./src/app/pages/withNavigation/recipes/edit/edit.html
// module id = 3114
// module chunks = 1